"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.diyListApi = diyListApi;
exports.splashGetApi = splashGetApi;
exports.splashSaveApi = splashSaveApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 提现申请 列表
 * @param pram
 */
function diyListApi(params) {
  return (0, _request.default)({
    url: '/admin/pagediy/list',
    method: 'get',
    params: params
  });
}
/**
 * 获取开屏广告
 */
function splashGetApi() {
  return (0, _request.default)({
    url: '/admin/page/layout/splash/ad/get',
    method: 'get'
  });
}
/**
 * 编辑开屏广告
 * @param data
 */
function splashSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/page/layout/splash/ad/save',
    method: 'post',
    data: data
  });
}